import React from "react";
import { Button } from "antd";
import './Operation.scss';

const ops = [
    { value: '1', label: 'Prześlij plik', description: 'Załaduj plik HTML lub inny na wybraną podstronę', icon: '📄' },
    { value: '2', label: 'Modyfikuj treść', description: 'Edytuj zawartość podstrony za pomocą edytora tekstu', icon: '✏️' },
];

export default function Operation(props: { val: string, setVal: (value: any) => void, prev: () => void, next: () => void }) {
    const handleSelect = (value: string) => {
        props.setVal(value);
        props.next();
    };

    return (
        <div className='operation'>
            <h2 className='operation__heading'>Wybierz operację</h2>
            <div className='operation__cards'>
                {ops.map(op => (
                    <button
                        key={op.value}
                        className={`operation__card ${props.val === op.value ? 'operation__card--active' : ''}`}
                        onClick={() => handleSelect(op.value)}
                    >
                        <span className='operation__card-icon'>{op.icon}</span>
                        <span className='operation__card-label'>{op.label}</span>
                        <span className='operation__card-desc'>{op.description}</span>
                    </button>
                ))}
            </div>
            <div className='operation__actions'>
                <Button onClick={() => props.prev()}>Cofnij</Button>
            </div>
        </div>
    );
}
